import type { ReactNode } from 'react';

export const symbol_house_with_shield: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M340-446q0 59 34.5 112.5T466-260q3.68 2 7 2.5t7 .5q3.68 0 7-.5t7-2.5q58.09-18.99 92.04-72.49Q620-386 620-446v-61q0-12.59-6.82-23.33Q606.36-541.07 595-547l-95-48q-9.51-5-19.76-5-10.24 0-20.24 5l-95 48q-11.36 5.93-18.18 16.67Q340-519.59 340-507v61ZM220-120q-24.75 0-42.37-17.63Q160-155.25 160-180v-390q0-14.25 6.38-27 6.37-12.75 17.62-21l260-195q15.68-12 35.84-12Q500-825 516-813l260 195q11.25 8.25 17.63 21 6.37 12.75 6.37 27v390q0 24.75-17.62 42.37Q764.75-120 740-120H220Zm0-60h520v-394L480-763 220-574v394Zm260-292Z"
		/>
	</svg>
);
